import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { FabricNotebookLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricNotebookLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FabricNotebookLinkedServiceAdapter extends LinkedServiceAdapter<FabricNotebookLinkedService> {

    protected modelConstructor(): new () => FabricNotebookLinkedService {
        return FabricNotebookLinkedService;
    }

    protected model(): IModel {
        return FabricNotebookLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: FabricNotebookLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }
    
    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: FabricNotebookLinkedService): Promise<FabricNotebookLinkedService> {
        return linkedService;
    }
}
